<section
    class="page-hero"
    [style.background-image]="'linear-gradient(rgba(61,70,83,.55), rgba(61,70,83,.55)), url(' + backgroundImage + ')'">

    <div class="container-redesign">

        <nav class="page-hero__breadcrumb">

            <ng-container *ngFor="let item of breadcrumbs; let last = last; trackBy: trackByLabel">

                <a
                    *ngIf="item.url && !last"
                    [routerLink]="item.url">
                    {{ item.label }}
                </a>

                <span *ngIf="!item.url || last">
                    {{ item.label }}
                </span>

                <span
                    class="page-hero__separator"
                    *ngIf="!last">
                    >
                </span>

            </ng-container>

        </nav>

        <h1 class="page-hero__title">
            {{ title }}
        </h1>

    </div>

</section>